import Axios from 'axios';

const BASE_URL = '/api/feestr';


export default {

    getAll() {
        return Axios.get(BASE_URL);
    },
    add(data) {
        return Axios.post(BASE_URL, data);
    },

    update(data) {
        return Axios.put(BASE_URL  +'/'+ data.id, data);
    },

    delete(id) {
        return Axios.delete(BASE_URL  +'/'+ id);
    }

}



// WEBPACK FOOTER //
// ./resources/assets/js/services/feestrs.js